import styled, { css } from 'styled-components';
import { rgba } from 'polished';

import {
  colors,
  layers,
  typography,
} from '../../theme';

import {
  HeadingOne,
} from '../../elements';

export const Wrapper = styled.div`
  bottom: 0;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
  opacity: 0;
  pointer-events: none;
  transition: opacity .5s ease-in-out,
              visibility .5s ease-in-out;
  visibility: hidden;
  z-index: ${layers.INTRO__CLOUD_ITEMS__TITLE};

  ${(props) => props.active && css`
    opacity: 1;
    visibility: visible;
  `}
`;

export const Container = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: calc(400vh - 12rem);
  left: 50%;
  position: absolute;
  top: 50%;
  transform: translate3D(-50%, -50%, 0);
  width: 400vw;
`;

export const Title = HeadingOne.extend`
  align-items: center;
  bottom: 0;
  display: flex;
  font-size: 80vh;
  flex-direction: column;
  justify-content: space-around;
  left: 0;
  line-height: 1;
  margin: 0;
  padding: 24vh 0 0 0;
  pointer-events: none;
  position: absolute;
  right: 0;
  top: 0;

  @media all and (max-width: 1023px) and (min-width: 667px) {
    font-size: 72vw;
    top: ${600 / typography.BASE_FONT_SIZE}rem;
    bottom: ${600 / typography.BASE_FONT_SIZE}rem;
  }

  @media screen and (max-width: 666px) {
    font-size: 76vw;
    top: ${720 / typography.BASE_FONT_SIZE}rem;
    bottom: ${720 / typography.BASE_FONT_SIZE}rem;
  }

`;

export const LogoWrapper = styled.div`
  left: 0;
  padding: 6rem;
  position: absolute;
  top: 0;
`;



// WEBPACK FOOTER //
// ./src/components/IntroTitle/style.js